import e from "./internal/_complement.mjs";
import o from "./internal/_curry2.mjs";
import m from "./filter.mjs";
var n = /* @__PURE__ */ o(function(r, t) {
  return m(e(r), t);
});
export {
  n as default
};
